import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "d-flex justify-space-between align-center mt-4 px-2 space-between" }
const _hoisted_2 = { style: {"width":"120px"} }
const _hoisted_3 = ["title"]
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "fab-container" }

import TestimonialForm from '@/components/TestimonialForm.vue'
import { ref, computed, onMounted, watch } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { HOST_URL_IMGS } from '@/utils/constantes'
import { ITestimonial } from '@/interfaces/testimonials.interface'


export default /*@__PURE__*/_defineComponent({
  __name: 'testimoniosView',
  setup(__props) {

const store = useStore()
const router = useRouter()
const testimonials = computed(() => store.state.Testimonials.TestimonialsList)
const statusInsertTestimonials = computed(() => store.state.Testimonials.statusInsertTestimonials)
const statusUpdateTestimonials = computed(() => store.state.Testimonials.statusUpdateTestimonials)
const statusDelTestimonials = computed(() => store.state.Testimonials.statusDelTestimonials)
// const estado = computed(() => store.state.Ui.status)


const dialogConfirm = ref(false)
const itemToDelete = ref<number | null>(null)
const aTestimonials = ref<ITestimonial[]>([])
const dialogPreview = ref(false)
const previewUrl = ref('')
const newImage = ref<File | null>(null)
const uploadType = ref<string>('')
const viewMode = ref<'grid' | 'list'>('grid')
const dialogEdit = ref(false)
const tab = ref<string>('HOME')
const loader = ref(false)
const snackbar = ref(false)
// const snackbarText = ref('')
const loadSkeleton = ref(false)

const totalItems = computed(() => store.state.Testimonials.totalItems)
const page = ref(1)
const itemsPerPage = ref(8)
const isEdit = ref(false)

const formData = ref<ITestimonial>({
  quote: '',
  rating: 0,
  couple: '',
  verse_references: '',
  verse: '',
  image: '',
  date: new Date().toISOString().split('T')[0], // formato YYYY-MM-DD
  type: '',
  status: 'A', // o 'inactive', según tu lógica
})

function openTab(newTab: string) {
  tab.value = newTab
  itemsPerPage.value = 8
  page.value = 1
  cargarTestimonios()
}
async function cargarTestimonios() {
  loadSkeleton.value = true
  await store.dispatch('Testimonials/fetchTestimonials', {
    params: {
      page: page.value,
      limit: itemsPerPage.value,
      type: tab.value,
    }
  })
  
  aTestimonials.value = testimonials.value?.data.items ?? []
  loadSkeleton.value = false
}

 
async function guardarTestimonios({ data, imageFile }: { data: ITestimonial; imageFile: File | null }) {
  loader.value = true
const pad = (n: any) => n.toString().padStart(2, '0');
const date = new Date(data.date);
const formatted = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate() + 1)}`;
  const formData = new FormData()
  formData.append('quote', data.quote ?? '')
  formData.append('rating', String(data.rating))
  formData.append('couple', data.couple ?? '')
  formData.append('verse_references', data.verse_references ?? '')
  formData.append('verse', data.verse ?? '')
  formData.append('date', String(formatted))
  formData.append('type', data.type)
  formData.append('status', data.status ?? 'A')
  if (imageFile) {
    formData.append('image', imageFile)
  } else if (data.image && !data.image.startsWith('http')) {
    try {
      const image = await urlToFile(getImagePath(data.image), data.image)
      formData.append('image', image)
    } catch (error) {
      console.error('Error convirtiendo imagen existente en archivo:', error)
    }
  }
  await store.dispatch('Testimonials/postTestimonials', formData)
  loader.value = false
  if (statusInsertTestimonials.value?.success) {
    dialogEdit.value = false
    cargarTestimonios()
  }
}

async function editarTestimonios({ data, imageFile }: { data: ITestimonial; imageFile: File | null }) {
  loader.value = true
  const pad = (n: any) => n.toString().padStart(2, '0');
  const date = new Date(data.date);
  const formatted = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate() + 1)}`;
  const formData = new FormData()
  formData.append('quote', data.quote ?? '')
  formData.append('rating', String(data.rating))
  formData.append('couple', data.couple ?? '')
  formData.append('verse_references', data.verse_references ?? '')
  formData.append('verse', data.verse ?? '')
  formData.append('date', String(formatted))
  formData.append('type', data.type)
  formData.append('status', data.status ?? 'A')
  if (imageFile) {
    formData.append('image', imageFile)
  } else if (data.image && !data.image.startsWith('http')) {
    try {
      const image = await urlToFile(getImagePath(data.image), data.image)
      formData.append('image', image)
    } catch (error) {
      console.error('Error convirtiendo imagen existente en archivo:', error)
    }
  }
  await store.dispatch('Testimonials/putTestimonial', {
    id: data.id,
    formData
  })
  loader.value = false  
  if (statusUpdateTestimonials.value?.success) {
    dialogEdit.value = false
    cargarTestimonios()
  }
}

async function deleteTestimonial(id: number) {
  await store.dispatch('Testimonials/delTestimonial', id)
  loader.value = false
  if (statusDelTestimonials.value?.success) {
    dialogConfirm.value = false
    cargarTestimonios()
  }
}

async function urlToFile(url: string, filename: string, mimeType = 'image/jpeg'): Promise<File> {
  const response = await fetch(url)
  const blob = await response.blob()
  return new File([blob], filename.split('/').pop() || 'image.jpg', { type: mimeType })
}
const confirmDelete = (id: number) => {
  itemToDelete.value = id
  dialogConfirm.value = true
}
const onItemsPerPageChange = () => {
  page.value = 1
  cargarTestimonios()
}
const performDelete = () => {
  if (itemToDelete.value !== null) {
    deleteTestimonial(itemToDelete.value)
    dialogConfirm.value = false
    itemToDelete.value = null
  }
}
function openUploadDialog(type: string) {
  isEdit.value = false
  uploadType.value = type
  formData.value = {
    quote: '',
    rating: 5,
    couple: '',
    verse_references: '',
    verse: '',
    image: '',
    date: new Date().toISOString().split('T')[0], // formato YYYY-MM-DD
    type: 'HOME',
    status: 'A', // o 'inactive', según tu lógica
  }
  dialogEdit.value = true
  newImage.value = null
}
const groupedTestimonial = computed(() => {
  if (!aTestimonials.value || !Array.isArray(aTestimonials.value)) return {}
  return aTestimonials.value.reduce<Record<string, ITestimonial[]>>((acc, item) => {
    if (!acc[item.type]) acc[item.type] = []
    acc[item.type].push(item)
    return acc
  }, {})
})
function getImagePath(path: string) {
  const baseURL = `${HOST_URL_IMGS}/public/imgs/output`
  return path.startsWith('http') ? path : baseURL + '/' + path
}
function previewImage(url: string) {
  previewUrl.value = url
  dialogPreview.value = true
}
watch(page, () => {
  cargarTestimonios()
})

function openEditDialog(g: ITestimonial) {
  isEdit.value = true
  formData.value = { ...g }
  dialogEdit.value = true
}
function cortarTexto(texto: string, max = 10) {
  return texto.length > max ? texto.slice(0, max) + '...' : texto
}
onMounted(() => {
  cargarTestimonios()
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_rating = _resolveComponent("v-rating")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_responsive = _resolveComponent("v-responsive")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_v_fab = _resolveComponent("v-fab")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { loading: loadSkeleton.value }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, {
            class: "d-flex justify-between space-between",
            style: {"justify-content":"space-between"}
          }, {
            default: _withCtx(() => [
              _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-h6" }, "Gestión de Testimonios", -1)),
              _createVNode(_component_v_btn_toggle, {
                modelValue: viewMode.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((viewMode).value = $event)),
                mandatory: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    value: "grid",
                    icon: "",
                    title: "Vista de Mosaico"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[15] || (_cache[15] = [
                          _createTextVNode("mdi-view-grid")
                        ])),
                        _: 1,
                        __: [15]
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    value: "list",
                    icon: "",
                    title: "Vista de Lista"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[16] || (_cache[16] = [
                          _createTextVNode("mdi-view-list")
                        ])),
                        _: 1,
                        __: [16]
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1,
            __: [17]
          }),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_pagination, {
              modelValue: page.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((page).value = $event)),
              length: Math.ceil(totalItems.value / itemsPerPage.value),
              "total-visible": 7,
              loading: true
            }, null, 8, ["modelValue", "length"]),
            _createVNode(_component_v_select, {
              modelValue: itemsPerPage.value,
              "onUpdate:modelValue": [
                _cache[2] || (_cache[2] = ($event: any) => ((itemsPerPage).value = $event)),
                onItemsPerPageChange
              ],
              items: [8, 16, 32, 64, 128],
              variant: "outlined",
              label: "Ítems por página",
              dense: "",
              style: {"max-width":"100px"}
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(_component_v_tabs, {
            modelValue: tab.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((tab).value = $event)),
            "align-tabs": "center",
            "fixed-tabs": "",
            grow: "",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (openTab(tab.value)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_tab, { value: "HOME" }, {
                default: _withCtx(() => _cache[18] || (_cache[18] = [
                  _createElementVNode("b", null, "HOME", -1)
                ])),
                _: 1,
                __: [18]
              }),
              _createVNode(_component_v_tab, { value: "CRIS" }, {
                default: _withCtx(() => _cache[19] || (_cache[19] = [
                  _createElementVNode("b", null, "CRIS", -1)
                ])),
                _: 1,
                __: [19]
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_v_tabs_window, {
            modelValue: tab.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((tab).value = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedTestimonial.value, (images, type) => {
                return (_openBlock(), _createBlock(_component_v_tabs_window_item, {
                  key: type,
                  value: type
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_container, { fluid: "" }, {
                      default: _withCtx(() => [
                        (viewMode.value === 'grid')
                          ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(images, (testimonial) => {
                                  return (_openBlock(), _createBlock(_component_v_col, {
                                    key: testimonial.id,
                                    cols: "12",
                                    sm: "6",
                                    md: "4",
                                    lg: "3"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_skeleton_loader, {
                                        loading: loadSkeleton.value,
                                        height: "240",
                                        type: "image, list-item-two-line"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_responsive, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_card, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_img, {
                                                    src: getImagePath(testimonial.image),
                                                    height: "200px",
                                                    cover: ""
                                                  }, null, 8, ["src"]),
                                                  _createVNode(_component_v_card_title, { class: "text-subtitle-1" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("#" + _toDisplayString(testimonial.id) + " " + _toDisplayString(testimonial.couple), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024),
                                                  _createVNode(_component_v_card_subtitle, {
                                                    title: testimonial.verse
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(testimonial.verse), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["title"]),
                                                  _createVNode(_component_v_card_text, {
                                                    title: testimonial.quote
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(cortarTexto(testimonial.quote, 40)), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["title"]),
                                                  _createVNode(_component_v_card_subtitle, null, {
                                                    default: _withCtx(() => [
                                                      _cache[20] || (_cache[20] = _createElementVNode("strong", null, "rating :", -1)),
                                                      _createVNode(_component_v_rating, {
                                                        "half-increments": "",
                                                        hover: "",
                                                        length: 5,
                                                        size: 15,
                                                        modelValue: testimonial.rating,
                                                        "onUpdate:modelValue": ($event: any) => ((testimonial.rating) = $event),
                                                        "active-color": "primary",
                                                        readonly: ""
                                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                    ]),
                                                    _: 2,
                                                    __: [20]
                                                  }, 1024),
                                                  _createVNode(_component_v_card_subtitle, null, {
                                                    default: _withCtx(() => [
                                                      _cache[21] || (_cache[21] = _createElementVNode("strong", null, "Estado :", -1)),
                                                      _createTextVNode(" " + _toDisplayString(testimonial.status === 'A' ? 'Activo' : 'Inactivo'), 1)
                                                    ]),
                                                    _: 2,
                                                    __: [21]
                                                  }, 1024),
                                                  _createVNode(_component_v_card_subtitle, null, {
                                                    default: _withCtx(() => [
                                                      _cache[22] || (_cache[22] = _createElementVNode("strong", null, "fecha :", -1)),
                                                      _createTextVNode(" " + _toDisplayString(testimonial.date), 1)
                                                    ]),
                                                    _: 2,
                                                    __: [22]
                                                  }, 1024),
                                                  _createVNode(_component_v_card_actions, null, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_btn, {
                                                        icon: "mdi-eye",
                                                        onClick: ($event: any) => (previewImage(getImagePath(testimonial.image)))
                                                      }, null, 8, ["onClick"]),
                                                      _createVNode(_component_v_spacer),
                                                      _createVNode(_component_v_btn, {
                                                        icon: "mdi-pencil",
                                                        color: "primary",
                                                        onClick: ($event: any) => (openEditDialog(testimonial))
                                                      }, null, 8, ["onClick"]),
                                                      _createVNode(_component_v_spacer),
                                                      _createVNode(_component_v_btn, {
                                                        icon: "mdi-delete",
                                                        color: "red",
                                                        onClick: ($event: any) => (confirmDelete(testimonial.id || -1))
                                                      }, null, 8, ["onClick"])
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["loading"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 2
                            }, 1024))
                          : (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_skeleton_loader, {
                                      loading: loadSkeleton.value,
                                      type: "article"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_table, {
                                          density: "compact",
                                          class: "mt-4",
                                          style: {"width":"-webkit-fill-available"}
                                        }, {
                                          default: _withCtx(() => [
                                            _cache[27] || (_cache[27] = _createElementVNode("thead", null, [
                                              _createElementVNode("tr", null, [
                                                _createElementVNode("th", null, "id"),
                                                _createElementVNode("th", null, "image"),
                                                _createElementVNode("th", null, "rating"),
                                                _createElementVNode("th", null, "Pareja"),
                                                _createElementVNode("th", null, "Referencias"),
                                                _createElementVNode("th", null, "Versículo"),
                                                _createElementVNode("th", null, "Fecha"),
                                                _createElementVNode("th", null, "Tipo"),
                                                _createElementVNode("th", null, "Cita"),
                                                _createElementVNode("th", null, "Estado"),
                                                _createElementVNode("th", null, "Acciones")
                                              ])
                                            ], -1)),
                                            _createElementVNode("tbody", null, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(images, (testimonial) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                  key: testimonial.id
                                                }, [
                                                  _createElementVNode("td", null, _toDisplayString(testimonial.id), 1),
                                                  _createElementVNode("td", _hoisted_2, [
                                                    _createVNode(_component_v_img, {
                                                      src: getImagePath(testimonial.image),
                                                      height: "60",
                                                      cover: ""
                                                    }, null, 8, ["src"])
                                                  ]),
                                                  _createElementVNode("td", null, _toDisplayString(testimonial.rating), 1),
                                                  _createElementVNode("td", null, _toDisplayString(testimonial.couple), 1),
                                                  _createElementVNode("td", null, _toDisplayString(testimonial.verse_references), 1),
                                                  _createElementVNode("td", {
                                                    title: testimonial.verse
                                                  }, _toDisplayString(testimonial.verse), 9, _hoisted_3),
                                                  _createElementVNode("td", null, _toDisplayString(testimonial.date), 1),
                                                  _createElementVNode("td", null, _toDisplayString(testimonial.type), 1),
                                                  _createElementVNode("td", {
                                                    title: testimonial.quote
                                                  }, _toDisplayString(cortarTexto(testimonial.quote, 20)), 9, _hoisted_4),
                                                  _createElementVNode("td", null, _toDisplayString(testimonial.status), 1),
                                                  _createElementVNode("td", null, [
                                                    _createVNode(_component_v_menu, null, {
                                                      activator: _withCtx(({ props }) => [
                                                        _createVNode(_component_v_btn, _mergeProps({
                                                          icon: "mdi-dots-vertical",
                                                          variant: "text"
                                                        }, { ref_for: true }, props), null, 16)
                                                      ]),
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_card, null, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_list, null, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_list_subheader, null, {
                                                                  default: _withCtx(() => _cache[23] || (_cache[23] = [
                                                                    _createTextVNode("OPCIONES")
                                                                  ])),
                                                                  _: 1,
                                                                  __: [23]
                                                                }),
                                                                _createVNode(_component_v_list_item, {
                                                                  onClick: ($event: any) => (previewImage(getImagePath(testimonial.image)))
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_list_item_title, null, {
                                                                      default: _withCtx(() => _cache[24] || (_cache[24] = [
                                                                        _createTextVNode("Ver")
                                                                      ])),
                                                                      _: 1,
                                                                      __: [24]
                                                                    })
                                                                  ]),
                                                                  _: 2
                                                                }, 1032, ["onClick"]),
                                                                _createVNode(_component_v_list_item, {
                                                                  onClick: ($event: any) => (openEditDialog(testimonial))
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_list_item_title, null, {
                                                                      default: _withCtx(() => _cache[25] || (_cache[25] = [
                                                                        _createTextVNode("Editar")
                                                                      ])),
                                                                      _: 1,
                                                                      __: [25]
                                                                    })
                                                                  ]),
                                                                  _: 2
                                                                }, 1032, ["onClick"]),
                                                                _createVNode(_component_v_list_item, {
                                                                  onClick: ($event: any) => (confirmDelete(testimonial?.id || -1))
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_list_item_title, null, {
                                                                      default: _withCtx(() => _cache[26] || (_cache[26] = [
                                                                        _createTextVNode("Eliminar")
                                                                      ])),
                                                                      _: 1,
                                                                      __: [26]
                                                                    })
                                                                  ]),
                                                                  _: 2
                                                                }, 1032, ["onClick"])
                                                              ]),
                                                              _: 2
                                                            }, 1024)
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ])
                                                ]))
                                              }), 128))
                                            ])
                                          ]),
                                          _: 2,
                                          __: [27]
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1032, ["loading"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["loading"]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_v_fab, {
          icon: "mdi-reload",
          size: "small",
          color: "primary",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (cargarTestimonios()))
        }),
        _createVNode(_component_v_fab, {
          icon: "mdi-plus",
          size: "small",
          color: "secondary",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (openUploadDialog(tab.value)))
        })
      ]),
      _createVNode(_component_v_dialog, {
        modelValue: dialogPreview.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((dialogPreview).value = $event)),
        "max-width": "800",
        scrollable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_img, {
                src: previewUrl.value,
                height: "auto",
                cover: ""
              }, null, 8, ["src"]),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    text: "",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (dialogPreview.value = false))
                  }, {
                    default: _withCtx(() => _cache[28] || (_cache[28] = [
                      _createTextVNode("Cerrar")
                    ])),
                    _: 1,
                    __: [28]
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        modelValue: dialogEdit.value,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((dialogEdit).value = $event)),
        "max-width": "800px",
        persistent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(isEdit.value ? 'Editar Imagen' : 'Agregar Imagen'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createVNode(TestimonialForm, {
                    modelValue: formData.value,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData).value = $event)),
                    isEdit: isEdit.value,
                    loading: loader.value,
                    onSubmit: editarTestimonios,
                    onSubmit2: guardarTestimonios,
                    onCancel: _cache[11] || (_cache[11] = () => dialogEdit.value = false)
                  }, null, 8, ["modelValue", "isEdit", "loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        modelValue: dialogConfirm.value,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((dialogConfirm).value = $event)),
        "max-width": "600px",
        persistent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "text-h6" }, {
                default: _withCtx(() => [
                  _cache[29] || (_cache[29] = _createTextVNode("¿Está seguro que desea eliminar el testimonio con ID ")),
                  _createElementVNode("b", null, "#" + _toDisplayString(itemToDelete.value), 1),
                  _cache[30] || (_cache[30] = _createTextVNode("?"))
                ]),
                _: 1,
                __: [29,30]
              }),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    color: "red",
                    text: "",
                    onClick: performDelete
                  }, {
                    default: _withCtx(() => _cache[31] || (_cache[31] = [
                      _createTextVNode("Eliminar")
                    ])),
                    _: 1,
                    __: [31]
                  }),
                  _createVNode(_component_v_btn, {
                    color: "grey",
                    text: "",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (dialogConfirm.value = false))
                  }, {
                    default: _withCtx(() => _cache[32] || (_cache[32] = [
                      _createTextVNode("Cancelar")
                    ])),
                    _: 1,
                    __: [32]
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})